import React, { useEffect, useState } from "react";
import { Button, Checkbox, Empty, InputNumber, message, Spin } from "antd";
import "./CartSummary.css";
import { MdDelete } from "react-icons/md";
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "../../services/sessionStorageServices";
import { getProfile } from "../../services/localStorageServices";
import { useCartContext } from "../../context/addToCart";
import { get, post } from "../../apiService";

const CartSummary = () => {
  const { profile } = getProfile();
  const [loading, setLoading] = useState(false);
  const { setCartValue, cartValue } = useCartContext();
  const [listCheck, setListCheck] = useState([]);

  const fetchCartDataFromAPI = async () => {
    setLoading(true);
    try {
      const action = "fetch";
      const limit = "10";
      const page = "1";
      const type = "cart";
      const user_id = profile.user_id;
      const status = "cart";
      // Replace with your API endpoint
      const response = await get(
        `/cart.php?action=${action}&limit=${limit}&page=${page}&type=${type}&user_id=${user_id}&status=${status}`
      );
      const fetchAddToCart = response.list;

      const insertDefaultValue = fetchAddToCart?.map((v, i) => ({
        ...v,
        defaultPicesValue: v.defaultCaratValue / v.avg_wt,
        defaultPrice: String(v.price / v.pcs),
        defaultCaratValue: v.avg_wt,
      }));
      setSessionStorageItem("cart", insertDefaultValue);
      setCartValue(insertDefaultValue);
      // setCartItems(response.list);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const removeCart = async (index, cart_id) => {
    if (window.confirm("Are you sure you want to remove from cart")) {
      try {
        const formData = new FormData();
        formData.append("action", "remove");
        formData.append("cart_id", cart_id);
        const response = await post("/cart.php", formData);
        if (response) {
          const prevData = [...cartValue];
          prevData.splice(index, 1);
          setCartValue(prevData);
          // setCartItems(prevData);
          if (prevData.length === 0) {
            sessionStorage.clear();
          } else {
            setSessionStorageItem("cart", prevData);
          }
        }
      } catch (error) {
        console.log("error deleted cart from add to cart");
      }
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchCart();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);

  const fetchCart = async () => {
    try {
      const storedCart = await getSessionStorageItem("cart");
      if (storedCart) {
        setCartValue(storedCart);
        console.log("State updated with:", storedCart);
      } else {
        await fetchCartDataFromAPI();
      }
    } catch (error) {
      console.error("Error updating cart value:", error);
    } finally {
      setLoading(false);
    }
  };

  const removeData = async () => {
    if (listCheck.length > 0) {
      if (window.confirm("are you sure you want to remove from cart")) {
        try {
          const formData = new FormData();
          formData.append("action", "removeAllData");
          formData.append("cart_id", listCheck.join(", "));
          const resp = await post("/cart.php", formData);

          if (resp) {
            const updatedCartValue = [...cartValue]; // Create a copy of cartValue
            listCheck.forEach((element) => {
              const index = updatedCartValue.findIndex(
                (val) => val.cart_id === element
              );
              if (index !== -1) {
                updatedCartValue.splice(index, 1);
              }
            });

            // Update the state and sessionStorage after the loop
            setCartValue(updatedCartValue);
            setListCheck([]);
            if (updatedCartValue.length === 0) {
              sessionStorage.clear();
            } else {
              setSessionStorageItem("cart", updatedCartValue);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    } else {
      message.error("No Data Selected");
    }
  };

  return (
    <>
      <div className="CartSummary-start-table-div">
        {cartValue?.length > 0 ? (
          <>
            <Button
              className="bg-danger d-none d-sm-flex text-white mb-4"
              style={{ height: "40px" }}
              icon={<MdDelete />}
              onClick={removeData}
            >
              Clear Cart
            </Button>

            <Spin spinning={loading}>
              <table className="cartSummary-table">
                <tr className="orderFilter-tr-th">
                  <th style={{ fontSize: ".85rem" }}>
                    <Checkbox
                      checked={listCheck.length > 0}
                      onChange={() =>
                        setListCheck((prev) =>
                          prev.length > 0 ? [] : cartValue.map((v) => v.cart_id)
                        )
                      }
                    />
                  </th>
                  <th style={{ fontSize: ".85rem" }}>Avg Weight</th>
                  <th style={{ fontSize: ".85rem" }} className="orderFilter-th">
                    Sieve
                  </th>
                  <th style={{ fontSize: ".85rem" }}>Size(MM)</th>
                  <th style={{ fontSize: ".85rem" }}>Color</th>
                  <th style={{ fontSize: ".85rem" }}>Shade </th>
                  <th style={{ fontSize: ".85rem" }}>Cut </th>
                  <th style={{ fontSize: ".85rem" }}>Clarity</th>
                  <th style={{ fontSize: ".85rem" }}>Price </th>
                  <th style={{ fontSize: ".85rem" }}>Type </th>
                  <th style={{ fontSize: ".85rem" }}>Selectd&nbsp;Type </th>
                  <th style={{ fontSize: ".85rem" }}>Total&nbsp;Weight </th>
                  <th style={{ fontSize: ".85rem" }}>Value</th>
                  <th style={{ fontSize: ".85rem" }}>action </th>
                </tr>

                {cartValue &&
                  cartValue
                    ?.sort((a, b) => a.avg_wt - b.avg_wt)
                    .map((v, i) => (
                      <tr className="orderFilter-tr-td">
                        <td>
                          <Checkbox
                            checked={listCheck.some((val) => val === v.cart_id)}
                            onChange={() =>
                              setListCheck(
                                (prev) =>
                                  prev.some((value) => value === v.cart_id)
                                    ? prev.filter(
                                        (value) => value !== v.cart_id
                                      ) // Remove if exists
                                    : [...prev, v.cart_id] // Add if doesn't exist
                              )
                            }
                          />
                        </td>
                        <td style={{ fontSize: ".85rem" }}>{v.avg_wt} </td>
                        <td className="orderFilter-td">{v.sive_sizes} </td>
                        <td style={{ fontSize: ".85rem" }}>{v.diam_mm}</td>
                        <td style={{ fontSize: ".85rem" }}>{v.color} </td>
                        <td style={{ fontSize: ".85rem" }}>{v.shade} </td>
                        <td style={{ fontSize: ".85rem" }}>{v.cut} </td>
                        <td style={{ fontSize: ".85rem" }}>{v.clarity} </td>
                        <td style={{ fontSize: ".85rem" }}>$&nbsp;{v.price}</td>
                        <td style={{ fontSize: ".85rem" }}>{v.product_type}</td>
                        <td style={{ fontSize: ".85rem" }}>
                          {v.product_type === "Carat" ? (
                            <>
                              <InputNumber
                                style={{
                                  minHeight: 33,
                                  maxWidth: "100px",
                                  borderColor:
                                    parseFloat(v.selected_type) > 10
                                      ? "red"
                                      : "#afafaf",
                                }}
                                value={parseFloat(v.selected_type).toFixed(2)}
                                step={0.01}
                                min={0.01}
                                onChange={(val) =>
                                  setCartValue((prev) => {
                                    const updatedDataList = [...prev];
                                    updatedDataList[i] = {
                                      ...updatedDataList[i],
                                      selected_type: val.toFixed(2),
                                      total_weight: parseFloat(val).toFixed(2),
                                      subtotal: (
                                        parseFloat(val) * v.price
                                      ).toFixed(2),
                                    };
                                    return updatedDataList;
                                  })
                                }
                              />
                              <br />
                              {parseFloat(v.selected_type) > 10 && (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: ".75rem",
                                  }}
                                >
                                  Max 10 Carat
                                </span>
                              )}
                            </>
                          ) : (
                            <InputNumber
                              style={{ minHeight: 33, maxWidth: "100px" }}
                              value={v.selected_type}
                              step={1}
                              onChange={(valu) =>
                                setCartValue((prev) => {
                                  const updatedDataList = [...prev];
                                  updatedDataList[i] = {
                                    ...updatedDataList[i],
                                    selected_type: valu,
                                    total_weight: parseFloat(
                                      valu * v.avg_wt
                                    ).toFixed(2),
                                    subtotal: (
                                      parseFloat(valu * v.avg_wt) * v.price
                                    ).toFixed(2),
                                  };
                                  return updatedDataList;
                                })
                              }
                            />
                          )}
                        </td>
                        <td style={{ fontSize: ".9rem" }}>{v.total_weight}</td>
                        <td style={{ fontSize: ".9rem" }}>
                          $&nbsp;{v.subtotal}
                        </td>
                        <td style={{ fontSize: ".9rem" }}>
                          <Button
                            className="orderFilter-add-to-cart"
                            type="link"
                            onClick={() => removeCart(i, v.cart_id)}
                          >
                            <MdDelete style={{ color: "rgb(235,87,87)" }} />
                          </Button>
                        </td>
                      </tr>
                    ))}
              </table>
            </Spin>
          </>
        ) : (
          <Empty />
        )}
      </div>

      <div className="diamond-cards-container">
        {cartValue.length > 0 && (
          <div className="d-flex align-items-center justify-content-between w-100">
            <Checkbox
              checked={listCheck.length > 0}
              style={{
                boxShadow: "0 0 3px #808080",
                background: "#fff",
                padding: "10px",
                borderRadius: "5px",
              }}
              onChange={() =>
                setListCheck((prev) =>
                  prev.length > 0 ? [] : cartValue.map((v) => v.cart_id)
                )
              }
            >
              Check All
            </Checkbox>
            <Button
              className="bg-danger text-white mb-4"
              style={{ height: "40px" }}
              icon={<MdDelete />}
              onClick={removeData}
            >
              Clear Cart
            </Button>
          </div>
        )}
        {cartValue && cartValue.length > 0 ? (
          cartValue
            ?.sort((a, b) => a.avg_wt - b.avg_wt)
            ?.map((v, i) => (
              <div key={i} className="diamond-card">
                <div className="row mb-1">
                  <div className="col-12">
                    <Checkbox
                      checked={listCheck.some((val) => val === v.cart_id)}
                      onChange={() =>
                        setListCheck(
                          (prev) =>
                            prev.some((value) => value === v.cart_id)
                              ? prev.filter((value) => value !== v.cart_id) // Remove if exists
                              : [...prev, v.cart_id] // Add if doesn't exist
                        )
                      }
                    >
                      Check This
                    </Checkbox>
                  </div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Sieve</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.sive_sizes}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Size(MM)</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.diam_mm}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Avg Weight</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.avg_wt}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Color</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.type}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Shade</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.shade}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Cut</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.cut}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Clarity</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.priceType}</div>
                </div>

                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Price</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">$ {v.price}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Type</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.product_type}</div>
                </div>
                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Selected Type </strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">
                    {v.product_type === "Carat" ? (
                      <>
                        <InputNumber
                          style={{
                            minHeight: 33,
                            maxWidth: "100px",
                            borderColor:
                              parseFloat(v.selected_type) > 10
                                ? "red"
                                : "#afafaf",
                          }}
                          value={v.selected_type}
                          step={0.001}
                          onChange={(val) =>
                            setCartValue((prev) => {
                              const updatedDataList = [...prev];
                              updatedDataList[i] = {
                                ...updatedDataList[i],
                                selected_type: val,
                                total_weight: parseFloat(val).toFixed(2),
                                subtotal: (parseFloat(val) * v.price).toFixed(
                                  2
                                ),
                              };
                              return updatedDataList;
                            })
                          }
                        />
                        <br />
                        {parseFloat(v.selected_type) > 10 && (
                          <span
                            style={{
                              color: "red",
                              fontSize: ".75rem",
                            }}
                          >
                            Max 10 Carat
                          </span>
                        )}
                      </>
                    ) : (
                      <InputNumber
                        style={{ minHeight: 33, maxWidth: "100px" }}
                        value={v.selected_type}
                        step={1}
                        onChange={(valu) =>
                          setCartValue((prev) => {
                            const updatedDataList = [...prev];
                            updatedDataList[i] = {
                              ...updatedDataList[i],
                              selected_type: valu,
                              total_weight: parseFloat(valu * v.avg_wt).toFixed(
                                2
                              ),
                              subtotal: (
                                parseFloat(valu * v.avg_wt) * v.price
                              ).toFixed(2),
                            };
                            return updatedDataList;
                          })
                        }
                      />
                    )}
                  </div>
                </div>

                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Total Weight</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">{v.total_weight}</div>
                </div>

                <div className="row mb-1">
                  <div className="col-6">
                    <strong>Value</strong>
                  </div>
                  <div className="col-2">-</div>
                  <div className="col-4">
                    $ {v.subtotal ? v.subtotal : v.updatedPrice}
                  </div>
                </div>
                <div className="diamond-card-row mt-3">
                  <Button
                    className="orderFilter-add-to-cart bg-danger orderFilter-add-to-cart-mobile-responsive"
                    type="link"
                    style={{ fontSize: ".9rem" }}
                    onClick={() => removeCart(i, v.cart_id)}
                  >
                    <MdDelete /> Remove From Cart
                  </Button>
                </div>
              </div>
            ))
        ) : (
          <div className="d-flex justify-content-center w-100">
            <Empty style={{ fontSize: "1.2rem" }} />
          </div>
        )}
      </div>
    </>
  );
};

export default CartSummary;
